/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: translations.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.12.22 4:17 pm.
 * Last modified: 08.12.22 4:17 pm.
 *
 * More information at: https://egt-digital.com/
 */
import * as config from '../config';
import store from '../eventStore';
import { defaultSettings } from '../interfaces/ISettings';
import { addBuildHash } from './helpers';

export const translations = (languageCode: string): void => {
    const currentSettings = store.SETTINGS.value;
    //// SKIP DEFAULT LANG FURTHER REQUESTS ////
    if (languageCode.toLocaleLowerCase() === defaultSettings.languageCode.toLocaleLowerCase()) {
        store.TRANSLATIONS.next({
            translationCode: languageCode,
            ...store.DEFAULT_LANG.value,
        });
        return;
    }
    const request = new XMLHttpRequest();
    request.addEventListener('load', function(): void {
        const responseValue = JSON.parse(this.responseText);
        store.TRANSLATIONS.next({
            translationCode: languageCode,
            ...responseValue,
        });
    });
    request.addEventListener('error', (): void => {
        store.EXTERNAL_CHANNEL.next({
            event: 'error',
            value: new Error('LOBBY.FETCH_TRANSLATIONS_FAILED'),
        });
    });
    request.open('GET', addBuildHash(config.getTranslationsUrl(currentSettings.host, languageCode)));
    request.send();
};

export const defaultTranslations = (): void => {
    const currentSettings = store.SETTINGS.value;
    const defaultLangRequest = new XMLHttpRequest();
    defaultLangRequest.addEventListener('load', function(): void {
        const defaultLang = JSON.parse(this.responseText);
        store.DEFAULT_LANG.next(defaultLang);
    });
    defaultLangRequest.addEventListener('error', (): void => {
        store.EXTERNAL_CHANNEL.next({
            event: 'error',
            value: new Error('LOBBY.FETCH_TRANSLATIONS_FAILED'),
        });
    });
    defaultLangRequest.open(
        'GET',
        addBuildHash(config.getTranslationsUrl(currentSettings.host, defaultSettings.languageCode)),
    );
    defaultLangRequest.send();
};
